'use strict';

var ActionTypes = require('../constants/ActionTypes'),
    AppDispatcher = require('../AppDispatcher');

var ActivityServerActionCreators = {
  handleActivitiesPage(err, response) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.REQUEST_ACTIVITIES_ERROR : ActionTypes.REQUEST_ACTIVITIES_SUCCESS,
      response: response
    });

    if (err) {
      console.error(err);
    }
  },

  handleUnseenCount(err, response) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.REQUEST_UNSEEN_ACTIVITY_COUNT_ERROR : ActionTypes.REQUEST_UNSEEN_ACTIVITY_COUNT_SUCCESS,
      count: response && response.count
    });

    if (err) {
      console.error(err);
    }
  },

  handleMarkAll(err) {
    AppDispatcher.handleServerAction({
      type: err ? ActionTypes.ACTIVITY_MARK_ALL_ERROR : ActionTypes.ACTIVITY_MARK_ALL_SUCCESS
    });

    if (err) {
      console.error(err);
    }
  }
};

module.exports = ActivityServerActionCreators;


/** WEBPACK FOOTER **
 ** ./actions/ActivityServerActionCreators.js
 **/